import ServicePageLayout from "./ServicePageLayout";

const BULLETS = [
  "Tonte régulière (hebdo, bi-mensuelle, mensuelle)",
  "Taille de haies, arbustes et arbres fruitiers",
  "Désherbage manuel ou mécanique",
  "Ramassage et évacuation des déchets verts",
  "Crédit d'impôt 50% pour les particuliers",
  "Contrat à l'année ou intervention ponctuelle",
];

const PROCESS = [
  { title: "Visite & devis", desc: "Estimation gratuite des besoins et fréquence." },
  { title: "Plan d'entretien", desc: "Calendrier sur-mesure, ponctuel ou annuel." },
  { title: "Interventions", desc: "Ponctualité et travail soigné à chaque passage." },
];

export default function EntretienJardinCreuse() {
  return (
    <ServicePageLayout
      slug="entretien-jardin-creuse"
      title="Entretien de jardin en Creuse — Crédit d'impôt 50%"
      seoTitle="Entretien jardin Creuse — Crédit d'impôt 50% | K'REUSE"
      seoDescription="Entretien de jardin Creuse (23) éligible crédit d'impôt 50%. Tonte, taille haies, désherbage, entretien régulier. Devis gratuit."
      badge="-50% Crédit d'impôt · Services à la personne"
      hero="Entretien régulier ou ponctuel de votre jardin, en Creuse. Notre prestation est éligible au crédit d'impôt de 50% au titre des services à la personne."
      intro="Tonte de pelouse, taille de haies, désherbage des massifs, nettoyage des allées : K'REUSE EXTÉRIEUR vous propose des contrats d'entretien régulier ou des interventions ponctuelles. En tant que particulier, vous bénéficiez du crédit d'impôt de 50% sur le coût des prestations (plafond 5 000 €/an pour les petits travaux de jardinage)."
      bullets={BULLETS}
      process={PROCESS}
      ctaTitle="Confiez l'entretien de votre jardin à un pro"
      ctaDesc="Contrat ou ponctuel — devis gratuit, crédit d'impôt 50%."
      image="/img/photos/entretien-jardin.webp"
      whatsappText="Bonjour, je souhaite un devis pour l'entretien de mon jardin (crédit d'impôt)."
    />
  );
}
